<template>
  <div
    class="p-8 max-w-3xl flex-no-grow"
    :class="{ 'load load--fill': loading }"
  >
    <h1 v-text="`Import errors for ${importName}`" />
    <div class="table-responsive">
      <table class="table table-files min-w-table">
        <thead>
          <tr>
            <th v-text="'Data'" />
            <th v-text="'Logs'" />
          </tr>
        </thead>
        <tbody>
          <tr
            is="FailedRow"
            v-for="row in failedRows"
            :key="row.uuid"
            :row="row"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script type="text/babel">
import FailedRow from './ImportErrorRow'

export default {
  name: 'ImportErrors',
  components: {
    FailedRow,
  },
  props: {
    memberCSVUploadUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      memberCSVUpload: {
        attributes: {
          original_filename: '',
        },
        failedRows: {
          data: [],
        },
      },
    }
  },
  computed: {
    failedRows() {
      return this.memberCSVUpload.failedRows.data
    },
    importName() {
      return this.memberCSVUpload.attributes.original_filename
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$api.active().get(`memberships/imports/${this.memberCSVUploadUuid}?include=failedRows.logs`)
        .then((response) => {
          this.memberCSVUpload = response.data
          this.loading = false
        })
    },
  },
}
</script>
